import wrapWithProvider from './wrap-with-provider'
import '@allied-solutions/affinity-sd/assets/fonts/stylesheet.css'
import 'react-datepicker/dist/react-datepicker.css'
import 'wicg-inert/dist/inert'
import { navigate } from 'gatsby';
export const wrapRootElement = wrapWithProvider

  export const onRouteUpdate = ({ location }) => {
    if (location.pathname === '/agent' || location.pathname === '/default.aspx' || location.pathname === '/account/') {
      navigate('/');
    }
  };
